import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "component-loader"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "loader-child loader-bounce1"
}, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "loader-child loader-bounce2"
}, null, -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "loader-child loader-bounce3"
}, null, -1);
const _hoisted_5 = [_hoisted_2, _hoisted_3, _hoisted_4];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.loading ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5)) : _createCommentVNode("", true);
}